import {
  ADD_RELIGION,
  ADD_RELIGION_FAILURE,
  ADD_RELIGION_SUCCESS,
  EDIT_RELIGION,
  EDIT_RELIGION_FAILURE,
  EDIT_RELIGION_SUCCESS,
} from '../Actiontype';

export const AddReligion = data => ({
  payload: data,
  type: ADD_RELIGION,
});
export const AddReligionSuccess = response => ({
  payload: response,
  type: ADD_RELIGION_SUCCESS,
});
export const AddReligionFailure = response => ({
  payload: response,
  type: ADD_RELIGION_FAILURE,
});
export const EditReligion = data => ({
  payload: data,
  type: EDIT_RELIGION,
});
export const EditReligionSuccess = response => ({
  payload: response,
  type: EDIT_RELIGION_SUCCESS,
});
export const EditReligionFailure = response => ({
  payload: response,
  type: EDIT_RELIGION_FAILURE,
});
